var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.04,
    y: 48.18,
    width: 51.1,
    height: 61.98,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.87,
    y: 53.84,
    width: 39.42,
    height: 50.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.87,
    y: 53.84,
    width: 1.54,
    height: 50.67,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.13,
    y: 48.18,
    width: 1.54,
    height: 61.98,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.08,
    y: 60.83,
    width: 9.29,
    height: 27.69,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.31,93.75H77.53V79.18h25.78Zm-24.78-1h23.78V80.18H78.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.76,
    y: 113.67,
    width: 51.1,
    height: 61.98,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.6,
    y: 119.33,
    width: 39.42,
    height: 50.66,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.6,
    y: 119.33,
    width: 1.54,
    height: 50.66,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.85,
    y: 113.67,
    width: 1.54,
    height: 61.98,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.49,
    y: 132.42,
    width: 7.96,
    height: 20.13,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.34,159H145V144.16h22.39ZM146,158h20.39V145.16H146Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.59,312.42l-13.12.28-6.66.11c-2.23.05-4.47,0-6.7.05h-.44v-.45l-.06-11.19v-.5h.5l13.24.06c4.42,0,8.83.11,13.24.17h.28v.27c0,1.9-.09,3.79-.13,5.65Zm0,0-.14-5.65c0-1.87-.11-3.71-.13-5.54l.27.27c-4.41.05-8.82.16-13.24.17l-13.24.06.5-.5,0,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.82,326.53l-13.12.28-6.66.11c-2.23.05-4.47,0-6.7.05H40.9v-.45l-.06-11.19v-.5h.5l13.24.06c4.41,0,8.83.11,13.24.17h.28v.27c0,1.9-.08,3.79-.13,5.65Zm0,0-.14-5.66c-.05-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.83.16-13.24.17l-13.24.06.5-.5-.05,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.09,107.29l-13.13.28-6.66.11c-2.22,0-4.46,0-6.69.06h-.45v-.45l0-11.19v-.5h.51l13.24.06c4.41,0,8.82.12,13.24.17h.27v.27c0,1.9-.09,3.79-.13,5.65Zm0,0-.15-5.65c0-1.87-.11-3.71-.13-5.54l.28.27c-4.42.06-8.83.16-13.24.17l-13.24.06.5-.5-.06,11.19-.44-.44c2.18,0,4.35,0,6.54.05l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.32,121.4l-13.13.28-6.66.11c-2.23,0-4.46,0-6.7.06h-.44v-.45l0-11.19v-.5h.5l13.25.06c4.41,0,8.82.12,13.24.17h.27v.27c0,1.9-.09,3.79-.13,5.65Zm0,0-.15-5.65c0-1.87-.11-3.71-.13-5.54l.28.27c-4.42.06-8.83.16-13.24.17l-13.25.06.5-.5-.05,11.19-.45-.44c2.19,0,4.36,0,6.55.05l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.6,107.29l-13.12.28-6.66.11c-2.23,0-4.47,0-6.7.06h-.44v-.45l-.06-11.19v-.5h.5l13.24.06c4.41,0,8.83.12,13.24.17h.28v.27c0,1.9-.08,3.79-.13,5.65Zm0,0-.14-5.65c-.05-1.87-.11-3.71-.13-5.54l.27.27c-4.41.06-8.83.16-13.24.17l-13.24.06.5-.5-.05,11.19-.45-.44c2.18,0,4.36,0,6.55.05l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.66,326.53l-13.13.28-6.66.11c-2.22.05-4.46,0-6.69.05h-.45v-.45l-.05-11.19v-.5h.5l13.24.06c4.41,0,8.83.11,13.24.17h.27v.27c0,1.9-.08,3.79-.13,5.65Zm0,0-.14-5.66c0-1.86-.12-3.7-.13-5.53l.27.27c-4.41.05-8.83.16-13.24.17l-13.24.06.5-.5-.06,11.19-.44-.45c2.18,0,4.36,0,6.54.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.65,207.18l-13.13.28-6.66.11c-2.22,0-4.46,0-6.69.05h-.44v-.45L348.67,196v-.5h.5l13.24.06c4.41,0,8.83.11,13.24.16h.28V196c0,1.9-.08,3.78-.13,5.65Zm0,0-.14-5.66c-.05-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.83.16-13.24.16l-13.24.07.5-.5-.06,11.19-.44-.45c2.18,0,4.36,0,6.54.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.89,52.85l-13.13.28-6.66.11c-2.22,0-4.46,0-6.69.06H417v-.45l0-11.19v-.5h.51l13.24.06c4.41,0,8.82.12,13.24.17h.27v.27c0,1.9-.09,3.79-.13,5.65Zm0,0-.14-5.65c-.05-1.87-.12-3.71-.14-5.54l.28.27c-4.42,0-8.83.16-13.24.17l-13.24.06.5-.5-.06,11.19-.44-.45c2.18,0,4.35,0,6.54.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.66,67l-13.13.28-6.66.11c-2.22.05-4.46,0-6.69.05h-.45V67l-.05-11.19v-.5h.5l13.24.06c4.41,0,8.83.12,13.24.17h.27v.27c0,1.9-.08,3.79-.13,5.65Zm0,0-.14-5.65c0-1.87-.12-3.71-.13-5.54l.27.27c-4.41.05-8.83.16-13.24.17l-13.24.06.5-.5L432.62,67l-.44-.45c2.18,0,4.36,0,6.54.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.59,52.85l-13.12.28-6.66.11c-2.23,0-4.47,0-6.7.06h-.44v-.45l-.06-11.19v-.5h.5l13.24.06c4.42,0,8.83.12,13.24.17h.28v.27c0,1.9-.09,3.79-.13,5.65Zm0,0-.14-5.65c0-1.87-.11-3.71-.13-5.54l.27.27c-4.41,0-8.82.16-13.24.17l-13.24.06.5-.5,0,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "37.02 341.56 90.27 341.31 143.51 341.23 250 341.06 356.49 341.23 409.74 341.31 462.98 341.56 409.74 341.8 356.49 341.89 250 342.06 143.51 341.89 90.27 341.8 37.02 341.56",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 428.84,
    rx: 198.49,
    ry: 14.68,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shelf--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 264.27,
    y: 123.4,
    width: 175.01,
    height: 7.67,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.08,
    y: 131.08,
    width: 7.68,
    height: 25.38,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.08,
    y: 131.08,
    width: 7.68,
    height: 7.85,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.79,
    y: 131.08,
    width: 7.68,
    height: 25.38,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.79,
    y: 131.08,
    width: 7.68,
    height: 7.85,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.84,
    y: 92.79,
    width: 48.91,
    height: 12.32,
    transform: "translate(406.24 -208.35) rotate(90)",
    style: {
      fill: "#3175DB"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.61,
    y: 75.25,
    width: 5.37,
    height: 12.32,
    transform: "translate(388.7 -225.89) rotate(90)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.3,
    y: 85.82,
    width: 1.99,
    height: 12.32,
    transform: "translate(399.28 -215.32) rotate(90)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.61,
    y: 108.14,
    width: 5.37,
    height: 12.32,
    transform: "translate(421.6 -193) rotate(90)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.23,
    y: 90.57,
    width: 57.06,
    height: 8.61,
    transform: "translate(412.63 -222.88) rotate(90)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.75,
    y: 80.1,
    width: 21.94,
    height: 5.17,
    transform: "translate(400.4 -235.04) rotate(90)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.46,
    y: 95.99,
    width: 57.06,
    height: 8.61,
    transform: "translate(174.47 -224.1) rotate(44.67)",
    style: {
      fill: "#3175DB"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 100.62,
    width: 21.94,
    height: 5.17,
    transform: "translate(177.37 -225.36) rotate(44.67)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.7,
    y: 94.43,
    width: 43.34,
    height: 14.62,
    transform: "translate(431.11 -227.62) rotate(90)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.35,
    y: 109.49,
    width: 4.04,
    height: 14.62,
    transform: "translate(446.16 -212.57) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.58,
    y: 104.04,
    width: 1.57,
    height: 14.62,
    transform: "translate(440.71 -218.02) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.72,
    y: 98,
    width: 40.73,
    height: 10.1,
    transform: "translate(399.14 -193.04) rotate(90)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.19,
    y: 112.15,
    width: 3.8,
    height: 10.1,
    transform: "translate(413.29 -178.89) rotate(90)",
    style: {
      fill: "#3175DB"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.19,
    y: 87.93,
    width: 3.8,
    height: 10.1,
    transform: "translate(389.07 -203.11) rotate(90)",
    style: {
      fill: "#3175DB"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.35,
    y: 93.16,
    width: 1.47,
    height: 10.1,
    transform: "translate(394.3 -197.88) rotate(90)",
    style: {
      fill: "#3175DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.09,71.23c-8.62,8.43-10.06,21.48-8.25,32.91.05.26.45.19.45-.06,0-2.6-.08-5.18-.07-7.75,0-.11.09-.22.14-.34A17.4,17.4,0,0,0,406,90c1.44-2.83,2-6,3.11-9,.1-.28-.2-.2-.4-.06-5.24,3.87-6.91,8-8.41,13.59a46.31,46.31,0,0,1,.91-8.66,29.45,29.45,0,0,1,7.16-14.41C408.46,71.31,408.24,71.08,408.09,71.23Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.71,72.21c1.48.05,2.41,2.42,3.56,3.11a1.11,1.11,0,0,0,1.64-.26c1.15-1.59-.43-3.56-1.9-4.67a16.11,16.11,0,0,0,3.07,1.42,1.08,1.08,0,0,0,1.39-.83c.5-2.18-2.23-3.15-4.11-3.2.91-.63,3.51-2.34,2.13-3.19S411,66.2,410,67c-1.47,1.19-3.22,3-3.28,4.82C406.67,74,408.57,72.67,409.71,72.21Z",
    style: {
      fill: "#3175DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.71,72.21c1.48.05,2.41,2.42,3.56,3.11a1.11,1.11,0,0,0,1.64-.26c1.15-1.59-.43-3.56-1.9-4.67a16.11,16.11,0,0,0,3.07,1.42,1.08,1.08,0,0,0,1.39-.83c.5-2.18-2.23-3.15-4.11-3.2.91-.63,3.51-2.34,2.13-3.19S411,66.2,410,67c-1.47,1.19-3.22,3-3.28,4.82C406.67,74,408.57,72.67,409.71,72.21Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.28,72.58c1.89-.86,5.54.38,5.84-.34.63-1.46-2.28-2.46-3.85-2.66,1.45-.39,4.22-1,4.13-2.41-.1-1.7-4.25-.24-6.34,1.37-2.65,2-2.63,4-2.19,4.38C407.47,73.46,409,72.72,409.28,72.58Z",
    style: {
      fill: "#3175DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.47,70.39c8.93,8.1,10.87,21.09,9.49,32.58,0,.26-.44.2-.45,0-.1-2.6-.12-5.18-.22-7.75l-.15-.34a17.33,17.33,0,0,1-5.82-5.79c-1.55-2.78-2.23-6-3.44-8.86-.12-.28.19-.2.39-.07,5.38,3.67,7.21,7.76,8.93,13.26A47.17,47.17,0,0,0,396,84.76a29.47,29.47,0,0,0-7.7-14.13C388.1,70.49,388.32,70.25,388.47,70.39Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.89,71.44c-1.48.1-2.32,2.51-3.45,3.24a1.11,1.11,0,0,1-1.64-.19c-1.2-1.56.29-3.59,1.72-4.74a16.71,16.71,0,0,1-3,1.53,1.08,1.08,0,0,1-1.42-.78c-.58-2.16,2.11-3.23,4-3.35-.93-.59-3.6-2.21-2.25-3.11s4.52,1.44,5.55,2.21c1.5,1.13,3.32,2.84,3.45,4.7C390,73.11,388.05,71.85,386.89,71.44Z",
    style: {
      fill: "#3175DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.89,71.44c-1.48.1-2.32,2.51-3.45,3.24a1.11,1.11,0,0,1-1.64-.19c-1.2-1.56.29-3.59,1.72-4.74a16.71,16.71,0,0,1-3,1.53,1.08,1.08,0,0,1-1.42-.78c-.58-2.16,2.11-3.23,4-3.35-.93-.59-3.6-2.21-2.25-3.11s4.52,1.44,5.55,2.21c1.5,1.13,3.32,2.84,3.45,4.7C390,73.11,388.05,71.85,386.89,71.44Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.33,71.79c-1.92-.79-5.51.59-5.85-.12-.68-1.43,2.18-2.55,3.75-2.8-1.46-.34-4.26-.85-4.22-2.25,0-1.71,4.23-.4,6.39,1.13,2.72,1.92,2.78,3.88,2.36,4.29C389.18,72.6,387.65,71.92,387.33,71.79Z",
    style: {
      fill: "#3175DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.6,91.79a88.42,88.42,0,0,0,2.77,12.8.32.32,0,0,0,.63-.12c-.59-4-1.66-7.82-2.24-11.77a58.85,58.85,0,0,1-.69-12.08c.38-6.65,2.18-13.73,6.52-18.93.1-.12-.11-.3-.2-.18-8.69,10.13-7.31,22.55-7.3,23.66-1.23-4.19-2.5-9-7.15-13.27-.2-.18-.36-.1-.33.22.84,7.78,3,11.84,7.51,16C397.25,89.35,397.41,90.58,397.6,91.79Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.67,62.85c1.56-.69,3.72,1.3,5.27,1.44a1.28,1.28,0,0,0,1.56-1.09c.39-2.24-2.23-3.49-4.32-3.89,1.31-.08,2.61.27,3.9-.08a1.24,1.24,0,0,0,1-1.56c-.58-2.51-3.9-2.14-5.87-1.25.63-1.11,2.46-4.2.6-4.38S403,56,402.39,57.29c-.92,2-1.84,4.69-1,6.66C402.42,66.24,403.72,63.9,404.67,62.85Z",
    style: {
      fill: "#3175DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.67,62.85c1.56-.69,3.72,1.3,5.27,1.44a1.28,1.28,0,0,0,1.56-1.09c.39-2.24-2.23-3.49-4.32-3.89,1.31-.08,2.61.27,3.9-.08a1.24,1.24,0,0,0,1-1.56c-.58-2.51-3.9-2.14-5.87-1.25.63-1.11,2.46-4.2.6-4.38S403,56,402.39,57.29c-.92,2-1.84,4.69-1,6.66C402.42,66.24,403.72,63.9,404.67,62.85Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.41,63.45c1.53-1.85,5.93-2.39,5.89-3.29-.08-1.83-3.6-1.41-5.33-.82,1.3-1.13,3.86-3.18,3.07-4.58-1-1.72-4.53,1.89-5.89,4.62-1.73,3.43-.72,5.45-.07,5.64C403,65.27,404.16,63.75,404.41,63.45Z",
    style: {
      fill: "#3175DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.88,94.13l-3.83,29.28h23.32c-.48-2.6-4.82-29.32-4.82-29.32Z",
    style: {
      fill: "#3175DB"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.08,162.83s25.09-3.51,19.23-33.8C97.31,129,69.27,135.32,78.08,162.83Z",
    style: {
      fill: "#3175DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.08,162.83s25.09-3.51,19.23-33.8C97.31,129,69.27,135.32,78.08,162.83Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.35,156.51A48.23,48.23,0,0,1,81.06,152l.06-.57c0-.42.07-.83.1-1.25.08-.91.13-1.81.19-2.71.1-1.81.22-3.63.25-5.44,0-.1.15-.09.15,0,0,1.81,0,3.62,0,5.43,0,.91-.09,1.81-.15,2.72,0,.2,0,.4,0,.6a53.56,53.56,0,0,1,5-8.6,42,42,0,0,1,2.75-3.48c1-1.15,2-2.24,3.06-3.37a.08.08,0,0,1,.11.11,45.26,45.26,0,0,0-4.84,6.43q-1.14,1.74-2.16,3.54l.23-.09.89-.36,2-.78c1.35-.49,2.7-1,4-1.5.08,0,.14.11.06.14-1.34.54-2.66,1.1-4,1.67l-1.94.83-1,.41a2.8,2.8,0,0,1-.67.23c-.5.91-1,1.82-1.47,2.75a66.35,66.35,0,0,0-3.06,7.23l-.18.52a14.82,14.82,0,0,1,2-1l2.6-1.18c1.76-.81,3.51-1.63,5.2-2.58a.07.07,0,1,1,.07.13c-1.72.94-3.41,1.94-5.14,2.88-.86.47-1.73.93-2.62,1.35a7.85,7.85,0,0,1-2.35,1,29.48,29.48,0,0,0-1.65,7.12c-.28,3.42-.25,6.87-.33,10.31,0,.06-.08.05-.09,0-.25-3.11-.39-6.25-.4-9.38A27.1,27.1,0,0,1,79.35,156.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.21,138.69a29.93,29.93,0,0,1,.25,5.35c0,.05-.07,0-.08,0-.1-1.77-.11-3.53-.32-5.3C83.05,138.63,83.2,138.6,83.21,138.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.39,140.21a18.53,18.53,0,0,0,3.22-1.59c.08-.05.16.09.08.14a12.54,12.54,0,0,1-3.26,1.56C90.37,140.33,90.32,140.24,90.39,140.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.28,210.92c0-2.78.07-5.55.1-8.32.06-9.21.13-18.42.3-27.62q.19-11,.51-21.93a.15.15,0,0,1,.06-.1l0-6c0-.05.06-.08.12-.08s.12,0,.12.08c0,2,0,4,0,6a.11.11,0,0,1,.06.09c.37,13,.7,26,.77,39,0,2.64,0,5.29,0,7.94q.14,12.72.1,25.45c0,1.35,0,2.7,0,4.05,0,7.76-.09,15.52-.09,23.29,0,.41-.46.62-.95.64s-1.17-.2-1.17-.68c0-8.56-.06-17.12-.06-25.68C77.26,221.71,77.24,216.31,77.28,210.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.76,202.49s12.07-8.94,23.52-2.9,13.25,29.34,13.25,29.34-16.82,2.4-27.41-7.68C86.91,211.54,87.76,202.49,87.76,202.49Z",
    style: {
      fill: "#3175DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.47,203.05a14.43,14.43,0,0,1,7-.92,10.44,10.44,0,0,1,1.48-.14l1.7-.13,3.52-.25c2.38-.18,4.77-.32,7.14-.56.09,0,.1.14,0,.15-2.35.3-4.69.64-7,.87-1.22.13-2.43.25-3.64.34l-.89.08c.36.09.72.17,1.07.27a28.51,28.51,0,0,1,5.47,2.22c1,.17,1.9.44,2.83.66,1.49.35,3,.74,4.46,1.12,2.94.77,5.84,1.64,8.74,2.48a.08.08,0,0,1,0,.15c-2.91-.71-5.83-1.37-8.74-2.06-1.42-.34-2.83-.67-4.24-1l-1.11-.25a35.23,35.23,0,0,1,8.57,7.46,46.15,46.15,0,0,1,6,9.4c0,.08-.08.17-.13.08a45.58,45.58,0,0,0-7.22-9.47c.06.16.11.32.16.48.22.71.45,1.42.67,2.14.45,1.42.9,2.84,1.32,4.26a.07.07,0,1,1-.14,0c-.51-1.38-1-2.76-1.48-4.15l-.72-2-.36-1.06-.12-.32a42.32,42.32,0,0,0-4.28-3.65,32.75,32.75,0,0,0-6.4-3.67l.12.62c.12.55.24,1.1.35,1.65.24,1.14.46,2.29.69,3.43.45,2.34.73,4.7,1.17,7,0,.1-.13.13-.15,0-.54-2.35-1.24-4.66-1.76-7-.26-1.18-.53-2.35-.77-3.53-.12-.55-.23-1.11-.34-1.66-.06-.31-.13-.61-.17-.92-.22-.09-.43-.19-.65-.27-3.17-1.17-6.67-2-10.05-1.38a9.89,9.89,0,0,0-7.26,5.82c-.11.27-.52.1-.46-.17C79.39,206.31,81.82,204.16,84.47,203.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.94,213l1,4.59a34,34,0,0,1,.84,4.46c0,.06-.08.06-.09,0a32.81,32.81,0,0,1-1-4.49c-.3-1.51-.59-3-.89-4.53C102.78,212.93,102.92,212.89,102.94,213Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.62,216.88c1.53.78,3,1.66,4.63,2.3.1,0,0,.19-.07.14a50,50,0,0,1-4.6-2.38A0,0,0,0,1,114.62,216.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,186.07s14.75.94,21.62-8.78S112,153.67,112,153.67s-15.5,1.88-21.65,8.87S85,186.07,85,186.07Z",
    style: {
      fill: "#3175DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.12,200.63c.51-1.58,1.14-3.14,1.74-4.69s1.19-3,1.84-4.42a89.76,89.76,0,0,1,4.42-8.69c1-1.79,2.15-3.53,3.3-5.25,0-.26.08-.52.12-.78.07-.46.13-.92.2-1.37.15-.94.31-1.87.47-2.8.34-2,.76-4.06,1.08-6.1,0-.09.17-.09.15,0-.29,2-.5,4-.78,6.05-.14,1-.26,2-.42,3,0,.36-.11.72-.16,1.08a105.89,105.89,0,0,1,7.29-9.47l1.08-1.2a3.45,3.45,0,0,1,.14-.34c.11-.28.21-.56.32-.85.21-.58.43-1.17.64-1.76.41-1.15.78-2.32,1.1-3.5,0-.1.17,0,.14,0-.3,1.21-.61,2.42-1,3.62-.18.57-.36,1.14-.57,1.71,0,.1-.07.19-.1.29,1.88-2.06,3.85-4,5.84-6,.07-.07.17,0,.1.11a106.2,106.2,0,0,0-10.45,12.81,8.73,8.73,0,0,1,1.09-.28c1.14-.22,2.28-.38,3.43-.53,2.4-.3,4.8-.61,7.19-1,.1,0,.14.12,0,.14-2.29.45-4.55,1-6.82,1.49-1.07.25-2.15.46-3.23.67a21.24,21.24,0,0,0-2.59.74c-.23.34-.48.67-.72,1-1.08,1.57-2.12,3.18-3.13,4.8l1.5-.29c1.14-.22,2.28-.43,3.43-.62,2.25-.37,4.5-.76,6.72-1.27.1,0,.14.13,0,.15-2.26.53-4.49,1.15-6.73,1.75-1.08.28-2.17.55-3.26.79L90,180a4.2,4.2,0,0,1-.66.12q-3.24,5.24-6,10.72c-.82,1.6-1.62,3.22-2.38,4.85s-1.47,3.39-2.19,5.09C78.54,201.14,78,201,78.12,200.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.22,166.73c.28-1.41.58-2.81.89-4.21,0-.1.16-.06.14,0-.27,1.38-.54,2.77-.79,4.15a41.57,41.57,0,0,1-.84,4.14s-.05,0,0,0A28.56,28.56,0,0,1,93.22,166.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.82,166.32c.69-.34,1.41-.62,2.12-.9l1.12-.43.57-.23a2.31,2.31,0,0,0,.62-.28c.11-.08.19.12.07.13a3.1,3.1,0,0,0-.63.26l-.55.25-1.08.48a19.34,19.34,0,0,1-2.18.86A.08.08,0,0,1,101.82,166.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.94,174.47S61,157.8,47.44,155.22s-21.9,11.39-21.9,11.39,9.91,12.65,22.37,14.86S69.94,174.47,69.94,174.47Z",
    style: {
      fill: "#3175DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.34,162.69a36.56,36.56,0,0,1,10.65.13l-.61-.33c-1-.51-2-1-3-1.55-2.09-1.08-4.2-2.24-6.38-3.11a.08.08,0,1,1,.06-.14c2.13,1,4.33,1.82,6.46,2.8,1.07.49,2.12,1,3.15,1.55.67.35,1.41.69,2.07,1.11A37.08,37.08,0,0,1,59.36,166l-1.69-1.85c-1.27-1.39-2.51-2.84-3.9-4.1-.08-.07,0-.17.11-.11,1.42,1.29,2.92,2.49,4.3,3.83.67.65,1.3,1.33,1.93,2,.31.35.62.7.92,1.07a35.81,35.81,0,0,1,18.2,24.59c0,.09-.11.15-.14.05a41.22,41.22,0,0,0-10-16.9,39.26,39.26,0,0,0-18.2-10.52A40,40,0,0,0,38.35,163C38.18,163,38.17,162.71,38.34,162.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.54,166.61s9.91,12.65,22.38,14.86c9.5,1.68,17.32-3.28,20.5-5.72l.68-1.12s-6.43-5.42-18.59-8.55S25.54,166.61,25.54,166.61Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.22,156.75a31.46,31.46,0,0,1,3,2,19.76,19.76,0,0,1,2.62,2.39.08.08,0,0,1-.12.11c-.9-.78-1.81-1.56-2.74-2.3a28.76,28.76,0,0,0-2.86-2.06C46.06,156.82,46.14,156.69,46.22,156.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.77,159.57c.5.21,1,.39,1.52.6l1.51.63c.11,0,.06.22,0,.17l-1.52-.61-1.5-.65C38.63,159.68,38.68,159.53,38.77,159.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.73,195.46S69.34,212,56.9,217.79s-27.6,0-27.6,0S35.26,182,71.73,195.46Z",
    style: {
      fill: "#3175DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.87,207c1.15-.13,2.29-.33,3.42-.54l1.68-.31c.28-.06.57-.13.87-.18.33-.31.66-.63,1-.93a49.56,49.56,0,0,1,7.6-5.51A41.79,41.79,0,0,1,57,197.21h-.23l-4.1.18c-2.73.13-5.46.19-8.18.36-.1,0-.1-.14,0-.15,2.74-.18,5.46-.49,8.2-.72l4-.35,2-.18.53-.06c.71-.26,1.42-.51,2.15-.74A19.46,19.46,0,0,1,71.93,195c3.13.8,6.25,2.85,7.06,6.15,0,.12-.15.19-.19.08-1.17-2.76-4.23-4.14-7-4.72a17,17,0,0,0-5.64-.11,12.88,12.88,0,0,1-.62,2.5c-.35,1.17-.69,2.33-1,3.49-.7,2.33-1.48,4.63-2.17,7a.08.08,0,0,1-.15-.05c.58-2.32,1.07-4.66,1.63-7,.27-1.14.56-2.28.84-3.42a22.23,22.23,0,0,1,.63-2.35,29.7,29.7,0,0,0-3.23.76,48.07,48.07,0,0,0-5.63,2.06c-.19,1.18-.45,2.35-.72,3.51-.34,1.46-.72,2.91-1.18,4.34a.07.07,0,0,1-.14,0,2.56,2.56,0,0,0,0-.27h0c.28-1.35.57-2.7.86-4.05.23-1.09.44-2.18.68-3.27a48.3,48.3,0,0,0-4.54,2.3c0,.33-.11.68-.16,1-.09.57-.19,1.14-.29,1.7-.24,1.28-.49,2.55-.8,3.81a59.41,59.41,0,0,1-2.14,7.19.08.08,0,0,1,0,.1l-.07.08c-.05.06-.14,0-.12-.08.57-2.45,1.23-4.88,1.77-7.34.26-1.23.54-2.45.78-3.69.13-.61.24-1.23.36-1.85,0-.17,0-.36.08-.55a52.54,52.54,0,0,0-12.26,10c-.08.1-.26,0-.18-.15a44.61,44.61,0,0,1,3-3.62c.62-.67,1.27-1.32,1.93-2l-.2,0-1.75.26c-1.16.15-2.31.26-3.46.4C37.81,207.19,37.77,207,37.87,207Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.61,212.64h0c0-.14,0-.28.07-.42s.13-.36.15-.54h0c.25-1.11.47-2.22.67-3.34,0-.08.14,0,.13,0a13.32,13.32,0,0,1-.94,4.32c0,.05-.1,0-.09,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,212.37a.08.08,0,0,1,.08-.07c.35-1.46.68-2.93,1-4.41.16-.77.32-1.54.47-2.32.08-.42.16-.84.23-1.26a3.82,3.82,0,0,1,.27-1.07.08.08,0,0,1,.14,0,7.09,7.09,0,0,1-.31,2.22c-.15.8-.31,1.61-.49,2.41-.36,1.63-.77,3.26-1.23,4.87a.08.08,0,0,1-.16,0C57,212.61,57,212.49,57,212.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,202.26c2.28-.31,4.55-.64,6.82-.91.1,0,.14.13,0,.15-2.27.33-4.54.61-6.82.91C39,202.42,38.91,202.28,39,202.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1,156.67s7.61-33.4-28.27-46.91C49.83,109.76,39.89,153.71,78.1,156.67Z",
    style: {
      fill: "#3175DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.35,137.73l-.38-.24-2-1.13L63.78,134c-2.74-1.53-5.44-3.12-8.2-4.62-.08,0,0-.18.08-.13,2.76,1.5,5.57,2.91,8.35,4.38l4.12,2.17,1.68.89c-1.2-2.27-2.48-4.5-3.88-6.64-1.88-2.86-3.93-5.59-6.07-8.25-.1-.12.06-.28.17-.17a56.77,56.77,0,0,1,8.3,10.17c0-.12,0-.24,0-.35,0-.83-.06-1.66-.08-2.49,0-1.63.06-3.26,0-4.89a.07.07,0,1,1,.15,0c.07,1.61.26,3.21.35,4.81,0,.8.08,1.6.11,2.4,0,.43,0,.93,0,1.4.73,1.18,1.44,2.37,2.12,3.58a62.76,62.76,0,0,1,3.2,6.72c0-.83.09-1.66.14-2.49.1-1.83.33-3.65.4-5.48a.08.08,0,0,1,.16,0c0,1.83,0,3.66,0,5.49,0,.92-.06,1.83-.12,2.74l-.06,1a61.38,61.38,0,0,1,2.71,9.18,97.54,97.54,0,0,1,1.33,10.08s0,0,0,0a54.28,54.28,0,0,0-1.91-9c-.44-1.58-.91-3.14-1.42-4.7-1.49-.7-2.92-1.58-4.36-2.38L66.55,145c-3-1.64-6-3.31-9.07-4.76-.09,0,0-.18.08-.14,3.13,1.42,6.28,2.77,9.35,4.31,1.53.77,3,1.59,4.52,2.43,1.25.7,2.53,1.4,3.72,2.21-.35-1-.71-2.07-1.11-3.1A89.26,89.26,0,0,0,70.35,137.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.38,130.09c0-.09.16-.09.15,0-.13,1.9-.19,3.81-.39,5.71,0,.1-.18.1-.17,0C73,133.89,73.24,132,73.38,130.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.18,136.47c2.24.9,4.51,1.76,6.74,2.7.07,0,0,.13,0,.1-2.26-.85-4.5-1.77-6.76-2.65C56,136.58,56.09,136.43,56.18,136.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.77,121.07a60.17,60.17,0,0,1,6.38,3.42c.1.07,0,.23-.1.17-2.08-1.22-4.2-2.39-6.36-3.46C52.6,121.16,52.68,121,52.77,121.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.31,
    y: 228.87,
    width: 51.74,
    height: 54.54,
    transform: "translate(158.36 512.28) rotate(180)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.96,
    y: 248.17,
    width: 2.65,
    height: 93.42,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.03,
    y: 248.17,
    width: 2.65,
    height: 93.42,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.59,
    y: 248.17,
    width: 2.65,
    height: 93.42,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.35,
    y: 279.91,
    width: 55.94,
    height: 7.55,
    transform: "translate(158.64 567.38) rotate(180)",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "415.18 395.9 400.55 395.9 378.76 264.13 415.18 264.13 415.18 395.9",
    style: {
      fill: "#3175DB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "415.18 395.9 400.55 395.9 378.76 264.13 415.18 264.13 415.18 395.9",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.18,
    y: 264.13,
    width: 29.42,
    height: 131.77,
    style: {
      fill: "#3175DB"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.18,
    y: 264.13,
    width: 29.42,
    height: 131.77,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.18,264.13c.23,8.6.34,17.21.42,25.81l.13,47.72-.12,25.81-.16,12.9-.27,12.9-.27-12.9-.16-12.9-.12-25.81.12-47.72C414.84,281.34,415,272.73,415.18,264.13Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.82 339.53 225.88 339.53 205.89 224.6 237.88 207.66 260.82 339.53",
    style: {
      fill: "#3175DB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.82 339.53 225.88 339.53 205.89 224.6 237.88 207.66 260.82 339.53",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.38 339.53 260.82 339.53 237.88 207.66 369.44 207.66 392.38 339.53",
    style: {
      fill: "#3175DB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.38 339.53 260.82 339.53 237.88 207.66 369.44 207.66 392.38 339.53",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.88 339.53 91.94 339.53 71.95 224.6 103.93 207.66 126.88 339.53",
    style: {
      fill: "#3175DB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.88 339.53 91.94 339.53 71.95 224.6 103.93 207.66 126.88 339.53",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.44 339.53 126.88 339.53 103.93 207.66 235.5 207.66 258.44 339.53",
    style: {
      fill: "#3175DB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.44 339.53 126.88 339.53 103.93 207.66 235.5 207.66 258.44 339.53",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.4,
    y: 264.13,
    width: 53.54,
    height: 131.77,
    style: {
      fill: "#3175DB"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.4,
    y: 264.13,
    width: 53.54,
    height: 131.77,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.94,
    y: 264.13,
    width: 29.42,
    height: 131.77,
    style: {
      fill: "#3175DB"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.94,
    y: 264.13,
    width: 29.42,
    height: 131.77,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.15,264.13l11.1-.2,11.11-.13h.33v.34l.13,12.86,0,34.77c0,8.57.07,17.14,0,25.71s0,17.14-.15,25.71-.19,17.14-.37,25.71q-.27-12.86-.38-25.71c-.1-8.57-.12-17.14-.14-25.71s0-17.14,0-25.71L137.9,277l.12-12.86.34.34-11.11-.14Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.36,
    y: 339.53,
    width: 276.82,
    height: 56.37,
    style: {
      fill: "#3175DB"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.36,
    y: 339.53,
    width: 276.82,
    height: 56.37,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.36,
    y: 315.16,
    width: 276.82,
    height: 24.6,
    style: {
      fill: "#3175DB"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.36,
    y: 315.16,
    width: 276.82,
    height: 24.6,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.18,339.53c-13.63.23-27.26.34-40.88.42l-40.88.13L179.24,340l-20.44-.16-20.44-.27,20.44-.27,20.44-.16L333.42,339l40.88.12C387.92,339.19,401.55,339.3,415.18,339.53Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.18,315.16c-13.63.23-27.26.34-40.88.42l-40.88.13-154.18-.12-20.44-.16-20.44-.27,20.44-.27,20.44-.16,154.18-.12,40.88.13C387.92,314.82,401.55,314.93,415.18,315.16Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.75 395.9 75.03 404.8 73.33 425.36 65.58 425.36 63.89 404.8 63.17 395.9 75.75 395.9",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.17 395.9 75.75 395.9 75.03 404.8 63.89 404.8 63.17 395.9",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.94 395.9 129.22 404.8 127.53 425.36 119.77 425.36 118.08 404.8 117.36 395.9 129.94 395.9",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.36 395.9 129.94 395.9 129.22 404.8 118.08 404.8 117.36 395.9",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.7 395.9 380.97 404.8 379.28 425.36 371.53 425.36 369.84 404.8 369.12 395.9 381.7 395.9",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.12 395.9 381.7 395.9 380.97 404.8 369.84 404.8 369.12 395.9",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.9 395.9 435.17 404.8 433.48 425.36 425.73 425.36 424.04 404.8 423.32 395.9 435.9 395.9",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.9 395.9 435.17 404.8 424.04 404.8 423.32 395.9 435.9 395.9",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.63,265.24a.65.65,0,0,0,0,1.3A.65.65,0,0,0,148.63,265.24Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M149.74,344.69a.65.65,0,0,0,0,1.3A.65.65,0,0,0,149.74,344.69Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M109.34,225.6a1.14,1.14,0,0,0-.1-.19.29.29,0,0,0-.5,0,1.14,1.14,0,0,0-.1.19C108.27,226.37,109.71,226.37,109.34,225.6Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M122.15,346.32a1.74,1.74,0,0,0-.1-.19.29.29,0,0,0-.5,0,1.74,1.74,0,0,0-.1.19C121.08,347.09,122.52,347.09,122.15,346.32Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M154.21,269.2a.5.5,0,0,0,0,1A.5.5,0,0,0,154.21,269.2Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M356.93,285.36a.5.5,0,0,0,0,1A.5.5,0,0,0,356.93,285.36Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M112.5,319.56a.5.5,0,0,0,0,1A.5.5,0,0,0,112.5,319.56Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M177.63,241.52a.7.7,0,0,0-1,0,1,1,0,0,0-.24.94.75.75,0,0,0,1.44,0A1,1,0,0,0,177.63,241.52Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M155.18,341a.7.7,0,0,0-1,0,1,1,0,0,0-.24.94.75.75,0,0,0,1.44,0A.94.94,0,0,0,155.18,341Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M67.91,289.83a.7.7,0,0,0-1,0,1,1,0,0,0-.24.94.76.76,0,0,0,1.45,0A1,1,0,0,0,67.91,289.83Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M406.26,326.84a.65.65,0,0,0,0-1.3A.65.65,0,0,0,406.26,326.84Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M268.77,230.35a.65.65,0,0,0,0-1.3A.65.65,0,0,0,268.77,230.35Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M277.32,347.71a.65.65,0,0,0,0-1.3A.65.65,0,0,0,277.32,347.71Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M245,261a.65.65,0,0,0,0-1.3A.65.65,0,0,0,245,261Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M364.08,279.37a1.86,1.86,0,0,0,.1.2.29.29,0,0,0,.5,0,1.86,1.86,0,0,0,.1-.2C365.15,278.6,363.71,278.6,364.08,279.37Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M305.5,341.58c0,.07.07.13.1.19a.3.3,0,0,0,.51,0,1.14,1.14,0,0,0,.1-.19C306.58,340.81,305.14,340.81,305.5,341.58Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M311.28,376.31a1.14,1.14,0,0,0,.1.19.29.29,0,0,0,.5,0,1.14,1.14,0,0,0,.1-.19C312.35,375.54,310.91,375.54,311.28,376.31Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M400.68,322.88a.5.5,0,0,0,0-1A.5.5,0,0,0,400.68,322.88Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M373.43,370.13a.7.7,0,0,0,1,0,1,1,0,0,0,.23-.94.75.75,0,0,0-1.44,0A1,1,0,0,0,373.43,370.13Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M435.41,277a.7.7,0,0,0,1,0,1,1,0,0,0,.24-.94.75.75,0,0,0-1.44,0A1,1,0,0,0,435.41,277Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M225.23,302.45a.68.68,0,0,0,1,0,.91.91,0,0,0,.23-.93.75.75,0,0,0-1.44,0A.94.94,0,0,0,225.23,302.45Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M159,184.84c.07-2.74.23-5.5.53-8.24a74.23,74.23,0,0,1,1.21-11.8c1.2-6.41,3.06-14.09,9.61-17a23.23,23.23,0,0,1,9.66-1.59c3.4,0,7,.46,9.83,2.53a8.73,8.73,0,0,1,2.67,3.09,21.85,21.85,0,0,1,5.9,4c2.24,1.55,3.42,4.45,4.08,7a35.89,35.89,0,0,1,.9,9.36,22,22,0,0,1-1.36,8.51,45.77,45.77,0,0,1-3.84,6.69,26.59,26.59,0,0,0-3.94,8.4.08.08,0,0,1-.16,0c.94-4.94,4.36-8.86,6.58-13.24a19.63,19.63,0,0,0,2.15-8,47.4,47.4,0,0,0-.34-9.6c-.41-2.69-1.26-5.81-3.13-8l.09.12c2,2.82,2.49,6.4,2.66,9.78a38.76,38.76,0,0,1-.85,11.27,36.89,36.89,0,0,1-4.17,9.39c-1.7,3-3.49,6-4.37,9.33-.93,3.53-.63,7.2-.25,10.78s.84,7,.36,10.46a15.24,15.24,0,0,1-4,8.41c-4.06,4.26-11.8,6.85-16.61,2.29a19.48,19.48,0,0,1-3-3.93,48.53,48.53,0,0,1-2.54-4.64,59.05,59.05,0,0,1-3.83-10.57,111.79,111.79,0,0,1-3.12-22.09c-.11-1.82-.18-3.66-.22-5.49a109.25,109.25,0,0,0,.15,12.4c.53,7.43,1.61,15.07,4.32,22a51.39,51.39,0,0,0,2.43,5.28c1,1.87,2.17,3.6,3.29,5.39.06.11-.08.22-.16.12a38.24,38.24,0,0,1-5.4-9.25,52.87,52.87,0,0,1-3.23-10.59A101.56,101.56,0,0,1,159,184.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,205.7c9.77,18.39,28.13,45.4,34.72,47.13,11,2.89,51.77,1.32,65.82-1.54,4.43-.9-.86-32.49-5.73-31.92-12.58,1.45-50.64,4.09-52,4-2.45-.21-19.23-14.47-32-25.61C174.76,187.22,171.41,197,176,205.7Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.85,218.59l3.74,36.35s-49.43,3.17-55.6-1.73-27.69-35.45-33-48.42,2.83-15.45,11.69-8S218,222,219,222.07,259.85,218.59,259.85,218.59Z",
    style: {
      fill: "#3175DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.87,223.49c.22,5.22,1.27,19.38,3.21,28.48,0,.05.23,0,.23,0-.41-7.82-2.41-23.31-3.11-28.49C253.19,223.36,252.86,223.39,252.87,223.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.29,255.33c-14,.66-43.62,1.59-48.3-2.12-6.18-4.9-27.69-35.45-33-48.43-3.12-7.58-1.62-11.58,1.93-12.1Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.23,193.4l0-.51.65-2.25s1.92.3,2.38,1.08a11.14,11.14,0,0,1,.83,2.38s9.37,4,12.25,6.76,23.05,19,25.38,19.65,26.64-3.11,29.56-2.78,4,1.58,4,1.58-35.05,3.55-37.31,2.76c-3-1-24.52-18.09-33.66-25.39Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.25,277.71c2.35.51,65.41-24.4,65.41-24.4l-9.79-21.79s3.09-7.6.68-14.4c-3.23-9.08-21.91-22.74-23.34-23.51-5.78-3.09-10.63-3.15-14.9-.33C145.5,205,145.25,277.71,145.25,277.71Z",
    style: {
      fill: "#3175DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.68,192.43l-17.41,6.4c.21-.35.44-.69.66-1L174.62,192C175,192.16,175.32,192.28,175.68,192.43Zm4.41,2.47-24.42,9-.39.91,25.52-9.4Zm4.3,3.3-30.83,11.35c-.1.3-.19.59-.28.88l31.77-11.7Zm4.06,3.38L152,215c-.07.28-.14.56-.22.85l37.31-13.74Zm3.82,3.47-41.55,15.3-.18.83,42.3-15.58C192.65,205.43,192.46,205.24,192.27,205.05Zm3.51,3.59-46.1,17c-.05.28-.09.55-.14.83l46.76-17.22C196.12,209,196,208.82,195.78,208.64Zm3.1,3.73-50.06,18.44-.13.81L199.3,213Zm2.37,4-53.16,19.57c0,.28-.07.55-.11.83l53.54-19.72C201.44,216.83,201.35,216.6,201.25,216.37Zm1.11,4.46-54.89,20.23c0,.27-.07.54-.1.8l55.06-20.28C202.42,221.33,202.39,221.08,202.36,220.83Zm-55.42,25.29c0,.27-.05.53-.07.8l55.3-20.37c0-.26.08-.53.11-.8ZM201,231.07l-54.55,20.09c0,.27,0,.53-.06.8L201,231.85l-.15-.33Zm1.57,4.31-56.49,20.8c0,.26,0,.52-.06.79L202.9,236Zm1.87,4.18-58.67,21.61c0,.26,0,.53,0,.79l59-21.74Zm1.88,4.19-60.79,22.38c0,.27,0,.53,0,.78l61.13-22.5Zm1.88,4.18-62.85,23.14c0,.27,0,.53,0,.78l63.17-23.26Zm1.89,4.18L145.27,276c0,.29,0,.55,0,.77l65.15-24Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.92,231.81a63.84,63.84,0,0,0-8.13,4.42c-1.28.85-2.51,1.75-3.73,2.68-.61.47-1.23.91-1.85,1.35a10,10,0,0,1-2.08,1.19.05.05,0,1,0,0,.1,15.82,15.82,0,0,0,2.12-.78,17.12,17.12,0,0,0,1.91-1.09c1.31-.85,2.57-1.76,3.87-2.62,2.62-1.74,5.23-3.47,8-5C190.17,232,190.05,231.75,189.92,231.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,231.89a69,69,0,0,0-7.32,2.16c-1.2.43-2.37.93-3.52,1.47q-.84.38-1.65.78c-.6.3-1.16.68-1.76,1-.07,0,0,.13,0,.1.58-.25,1.2-.41,1.79-.63l1.79-.68,3.57-1.33c2.37-.92,4.74-1.81,7.15-2.64C198.2,232,198.12,231.86,198,231.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.9,369.66c.56-2.66,38-66.36,40.93-67.88,1.12-.59,3.22-2.6,14.65,3.66l21-22,16.66,41-54.13,29s-25.23,18-28.66,19.31S168.34,372.32,168.9,369.66Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.9,369.66c.56-2.66,38-66.36,40.93-67.88,1.12-.59,3.22-2.6,14.65,3.66l21-22,16.66,41-54.13,29s-25.23,18-28.66,19.31S168.34,372.32,168.9,369.66Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,341.68,208,353.49s-25.23,18-28.65,19.31-11-.48-10.42-3.14,38-66.35,40.92-67.88c1.13-.59,3.23-2.6,14.65,3.65l2.22-2.32Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,342.29a15.72,15.72,0,0,1,4.11-4.54,13.7,13.7,0,0,1-1.83,2.48A13.19,13.19,0,0,1,225,342.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.6,338.3a13.2,13.2,0,0,1,1.82-2.48,13.57,13.57,0,0,1,2.28-2.06,13.58,13.58,0,0,1-1.82,2.47A14.07,14.07,0,0,1,224.6,338.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.19,334.3a13.63,13.63,0,0,1,1.83-2.47,13.19,13.19,0,0,1,2.28-2.06,14,14,0,0,1-1.83,2.47A13.19,13.19,0,0,1,224.19,334.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.79,330.31a14,14,0,0,1,1.82-2.48,13.57,13.57,0,0,1,2.28-2.06,15.18,15.18,0,0,1-4.1,4.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.38,326.31a14,14,0,0,1,1.83-2.47,13.19,13.19,0,0,1,2.28-2.06,13.63,13.63,0,0,1-1.83,2.47A13.19,13.19,0,0,1,223.38,326.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223,322.32a13.58,13.58,0,0,1,1.82-2.47,14.07,14.07,0,0,1,2.28-2.07,15.18,15.18,0,0,1-4.1,4.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.57,318.33a13.7,13.7,0,0,1,1.83-2.48,13.19,13.19,0,0,1,2.28-2.06,15.72,15.72,0,0,1-4.11,4.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.17,314.33a15.3,15.3,0,0,1,4.1-4.53,15.3,15.3,0,0,1-4.1,4.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.76,310.34a14.06,14.06,0,0,1,1.83-2.48,13.19,13.19,0,0,1,2.28-2.06,14.06,14.06,0,0,1-1.83,2.48A13.61,13.61,0,0,1,221.76,310.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.07,271.83c-5.21,19.59-97.17,71.9-97.17,71.9l-20.72-49,42.34-22.68-94.45-5.37,46-22s9.37,3,15.86.49c2.88-1.11,64.92-15.4,77.41-13.45C329.9,236.08,337.86,253.85,333.07,271.83Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.43,258.63a48.82,48.82,0,0,0-5.18,3.13c-1.79,1.11-3.59,2.19-5.38,3.3l-.05,0L269,264c1.35-1.27,2.56-2.65,4-3.8.09-.07,0-.2-.11-.14-1.47,1.13-3.07,2.13-4.45,3.39-.64.59-1.27,1.19-1.88,1.82-.34.34-.68.69-1,1.05-.14.16-.31.33-.45.51-.81.53-1.61,1.05-2.41,1.6-1.76,1.21-3.43,2.56-5.2,3.76-.09.06,0,.19.11.14,1.75-1.09,3.6-2,5.36-3.1s3.55-2.24,5.29-3.42,3.38-2.31,5.07-3.46a49.94,49.94,0,0,0,5.17-3.57C278.55,258.7,278.5,258.6,278.43,258.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.1,331.16c-.53-1.4-1.08-2.79-1.64-4.18-1.11-2.78-2.21-5.56-3.34-8.33-2.24-5.51-4.48-11-6.85-16.49-1.34-3.09-2.67-6.19-4.14-9.22a.15.15,0,0,0-.28.11c2,5.65,4.27,11.2,6.57,16.72s4.61,11,7,16.44c.66,1.53,1.31,3.06,2,4.58s1.47,3.08,2.15,4.64a.07.07,0,0,0,.12-.05C241.1,334,240.64,332.56,240.1,331.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.7,293.14c-2,1.83-69.48,31.89-72.78,31.41-1.25-.17-4.13.24-9.78-11.49-1.22-2.54-54.65-13.24-54.65-13.24l46.72-32.13,49.3,15.88s31,0,34.55,1S426.71,291.3,424.7,293.14Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.7,293.13c-2,1.85-69.47,31.9-72.78,31.43-1.24-.18-4.13.23-9.78-11.51-.34-.69-4.57-2-10.56-3.51l42.43-29,9.51,3.06s31,.06,34.54,1S426.7,291.3,424.7,293.13Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,308.9a14,14,0,0,1,3,.49,13.27,13.27,0,0,1,2.87,1.07A15.26,15.26,0,0,1,335,308.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.32,306.71a14,14,0,0,1,3,.48,14.15,14.15,0,0,1,2.88,1.08,13.39,13.39,0,0,1-3-.48A14.15,14.15,0,0,1,338.32,306.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.69,304.52a13.39,13.39,0,0,1,3,.48,13.58,13.58,0,0,1,2.88,1.08,13.4,13.4,0,0,1-3-.49A13.81,13.81,0,0,1,341.69,304.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.05,302.32a13.89,13.89,0,0,1,3,.49,13.69,13.69,0,0,1,2.88,1.07,15.26,15.26,0,0,1-5.91-1.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.41,300.13a15.14,15.14,0,0,1,5.91,1.56,13.39,13.39,0,0,1-3-.48A13.93,13.93,0,0,1,348.41,300.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.77,297.94a13.39,13.39,0,0,1,3,.48,13.58,13.58,0,0,1,2.88,1.08,13.4,13.4,0,0,1-3-.49A14.11,14.11,0,0,1,351.77,297.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.14,295.74a14,14,0,0,1,3,.49,13.58,13.58,0,0,1,2.88,1.08,14,14,0,0,1-3-.49A13.3,13.3,0,0,1,355.14,295.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.5,293.55a14,14,0,0,1,3,.48,13.72,13.72,0,0,1,2.88,1.08,13.22,13.22,0,0,1-3-.48A13.72,13.72,0,0,1,358.5,293.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.86,291.36a15.26,15.26,0,0,1,5.91,1.56,13.32,13.32,0,0,1-3-.49A13.69,13.69,0,0,1,361.86,291.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.22,289.16a14,14,0,0,1,3,.49,13.3,13.3,0,0,1,2.87,1.08,14,14,0,0,1-3-.49A13.58,13.58,0,0,1,365.22,289.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.58,287a14,14,0,0,1,3,.48,14.15,14.15,0,0,1,2.88,1.08,13.39,13.39,0,0,1-3-.48A14.15,14.15,0,0,1,368.58,287Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372,284.78a13.39,13.39,0,0,1,3,.48,13.19,13.19,0,0,1,2.88,1.08,15.14,15.14,0,0,1-5.91-1.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.31,282.58a13.79,13.79,0,0,1,3,.49,13.19,13.19,0,0,1,2.88,1.08,13.79,13.79,0,0,1-3-.49A13.19,13.19,0,0,1,375.31,282.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.82,279.32l-49,33.84-85.29-25.47s-15.66,17-34.4,24c-12.76,4.72-35.35,6.63-48.64-6.85-11.19-11.36-8.46-27.42-8.46-27.42L160,268s31.18-31.44,53-37.54C246.28,221.11,371.82,279.32,371.82,279.32Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.73,256.92c-1.93,1.65-3.78,3.39-5.68,5.08s-3.82,3.25-5.57,5-3.46,3.73-5.12,5.66c-.8.94-1.6,1.87-2.37,2.83a24.41,24.41,0,0,0-2.22,3c-.06.1.08.2.17.13a27.9,27.9,0,0,0,2.55-2.55c.89-.91,1.77-1.84,2.65-2.76,1.71-1.78,3.46-3.52,5.16-5.31s3.24-3.67,4.91-5.46,3.7-3.73,5.57-5.56C171.82,257,171.77,256.89,171.73,256.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.56,287.68a110.46,110.46,0,0,1-11.74,10.65l-25.13-22.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.7,277.58c-1.47.88-2.89,1.87-4.31,2.83l-4.2,2.84c-2.85,2-5.67,4-8.5,6-5.66,4-11.28,8.09-16.9,12.17-3.15,2.28-6.25,4.62-9.38,6.92-.06.05,0,.15.07.11q8.58-5.7,17.07-11.53t17-12.08q2.34-1.71,4.63-3.47c1.55-1.19,3.15-2.35,4.63-3.62C359.86,277.65,359.78,277.53,359.7,277.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.31,262.83c-1.49-.85-35.59-14.1-42.16-16.48s-13.15-4.61-19.8-6.7-13.33-4-20.09-5.62S238.83,231,232,230c-.88-.12-1.75-.24-2.62-.39-.08,0-.09.12,0,.13,3.47.57,6.89,1.38,10.31,2.14s6.73,1.56,10.08,2.42q10.05,2.58,19.94,5.73c6.58,2.07,13.11,4.32,19.59,6.69s13,4.84,19.5,7.37c3.23,1.26,24.53,8.79,25.36,9C334.33,263.15,334.47,262.93,334.31,262.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.77,305.58c-3.21-1.11-15.8-5.36-19-6.39s-6.49-2-9.74-3q-9.66-2.9-19.38-5.64c-3.66-1-7.34-2.1-11.05-2.91-.08,0-.13.09,0,.12,3.17,1.2,6.43,2.21,9.67,3.2s6.49,2,9.74,3c6.44,1.94,12.88,3.9,19.37,5.66,3.67,1,16.69,5.3,20.39,6.21C296.83,305.83,296.91,305.63,296.77,305.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.23,193.18c.2,1.19,5.34,9.17,10.73,9.25,1.75,0,2.31-9.54,2.31-9.54l.2-.7,2.83-9.76-12.79-9.28S168.15,192.68,168.23,193.18Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.47,192.18l-.2.71s0,.41-.08,1.08a21.23,21.23,0,0,1-11.43-10.5c.86-5.1,1.76-10.32,1.76-10.32l12.78,9.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.2,170.09c.8,17.82-9.79,20.31-13.63,20.47-3.49.16-15.39.23-18-17.41s5.39-23.65,13.35-24.42S197.4,152.26,198.2,170.09Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.34,176.69l2-2.36s.52,3.19.44,3.17Z",
    style: {
      fill: "#c96355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.53,170.6c-2.31-.53-3.19,4.12-1.06,4.6S187.46,171,185.53,170.6Z",
    style: {
      fill: "#c96355",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.67,170.7c-2.26,0-2.17,4.5-.07,4.54S196.57,170.73,194.67,170.7Z",
    style: {
      fill: "#c96355",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.94,182.29c.26.31.52.74,1,.82a3.32,3.32,0,0,0,1.36-.18s.07,0,0,.07a1.64,1.64,0,0,1-1.62.51,1.33,1.33,0,0,1-.87-1.18C184.8,182.26,184.9,182.24,184.94,182.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.13,177.42a26.84,26.84,0,0,1,.15,2.73,18.1,18.1,0,0,0-5.06.53c-.39.12-.37-.2.07-.45a7.5,7.5,0,0,1,4.27-.87c.07-.24-.33-2.85-.19-2.86a7.68,7.68,0,0,1,2,.53c-.27-3.88-1.16-7.69-1.37-11.56a.12.12,0,0,1,.23,0,63.15,63.15,0,0,1,2,12.38C193.24,178.3,191.48,177.58,191.13,177.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.16,180.18s-.92,2.06-2.24,2.21c-1.51.16-1.92-1.69-.22-2.38A4.48,4.48,0,0,1,189.16,180.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.47,181.32a2.45,2.45,0,0,1-1.55,1.06,1.09,1.09,0,0,1-1.33-1h0s0,0,0,0C187.18,180.6,188,180.88,188.47,181.32Z",
    style: {
      fill: "#ff99ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.4,167.42c-.36-.22-.72-.37-1.1-.56a2,2,0,0,0-1.22-.36.62.62,0,0,0-.49.6,1.56,1.56,0,0,0,1,1.26,2.35,2.35,0,0,0,1.64.29A.68.68,0,0,0,196.4,167.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.54,168.22a10,10,0,0,1,1.17-.38,1.94,1.94,0,0,1,1.27-.17.66.66,0,0,1,.39.67,1.6,1.6,0,0,1-1.16,1.1,2.34,2.34,0,0,1-1.67,0A.68.68,0,0,1,183.54,168.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.45,171.59c0-.05-.1.06-.09.11,0,1.21-.13,2.61-1.23,3,0,0,0,.07,0,.07C186.48,174.59,186.68,172.73,186.45,171.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.37,170.32c-2-.15-2.12,3.76-.31,3.91S187,170.45,185.37,170.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.45,170.89c-.36.21-.71.59-1.12.61s-.82-.39-1.12-.8c0,0-.07,0-.07,0,0,.75.22,1.53,1,1.68s1.28-.51,1.5-1.26C184.7,171,184.59,170.81,184.45,170.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.2,171.71c0-.05.09.06.09.11,0,1.21.18,2.6,1.29,3,0,0,0,.07,0,.06C193.22,174.71,193,172.86,193.2,171.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.26,170.42c2-.19,2.18,3.73.37,3.9S192.62,170.58,194.26,170.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.27,171.2c.32.19.65.55,1,.55s.72-.44,1-.86c0,0,.06,0,.07,0,.06.74-.14,1.54-.85,1.72s-1.17-.44-1.39-1.17C195.05,171.34,195.14,171.12,195.27,171.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.22,171.37l2.58.13s-.37-1.36-1.43-1.26A1.26,1.26,0,0,0,193.22,171.37Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,171.17l2.48.17s-.26-1.11-1.12-1.13S184,171.17,184,171.17Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.15,152.61a7.74,7.74,0,0,1-.7,4.47c-2.27,3.67-6.82,2.15-8.58,3.5s-1.45,4.3-3,5.59c-2.09,1.79-4.56.74-5,2s-1.8,5.47-3.57,5.83-6.52-28.81,15.67-25.51c0,0,3.19-.92,7.67,2s6.68,12.2,6.68,12.2a5.49,5.49,0,0,1-1.17-1c-1-1.07-1.29-2-2-2.69-1.14-1.1-1.86-.81-3-1.88A14.72,14.72,0,0,1,188.15,152.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.94,151.35a14.49,14.49,0,0,1,.28,3.47,6.23,6.23,0,0,1-.83,3.26,4.62,4.62,0,0,1-2.77,1.72c-1.1.27-2.28.26-3.47.59a3.51,3.51,0,0,0-1.62,1,4.65,4.65,0,0,0-.84,1.64,6.16,6.16,0,0,1-1.57,2.95,3.83,3.83,0,0,1-3.12.93c-1.12-.12-2.33-.57-3.48-.19,1.18-.28,2.28.24,3.44.46a4.25,4.25,0,0,0,3.44-.87,6.31,6.31,0,0,0,1.77-3.11,4.06,4.06,0,0,1,.76-1.46,3,3,0,0,1,1.38-.78c1.06-.32,2.26-.33,3.43-.64a6,6,0,0,0,1.68-.69,3.63,3.63,0,0,0,1.33-1.28,6.57,6.57,0,0,0,.75-3.49A15,15,0,0,0,187.94,151.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.26,152.41a12.17,12.17,0,0,0,.75,3.18,5.68,5.68,0,0,0,2,2.7,8.65,8.65,0,0,0,1.47.77,2.64,2.64,0,0,1,1.12.93,7.71,7.71,0,0,0,.83,1.42,3.62,3.62,0,0,0,1.32,1,4,4,0,0,1-1.1-1.14,8,8,0,0,1-.67-1.45,2.88,2.88,0,0,0-1.26-1.21,8.63,8.63,0,0,1-1.39-.74,6.12,6.12,0,0,1-1.88-2.43A23.71,23.71,0,0,1,188.26,152.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.44,174.39s-3.66-5.72-6.24-4.44,0,9.47,2.92,10.69a3,3,0,0,0,4.11-1.45Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,172.28c-.05,0-.06.06,0,.08,2,.92,3.06,2.9,3.74,4.93a1.66,1.66,0,0,0-2.47-.56c-.06,0,0,.12.05.11a1.85,1.85,0,0,1,2,.73,8.87,8.87,0,0,1,.91,1.69c.09.19.43.11.37-.11v-.05C168.74,176.46,166.83,172.66,164,172.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.14,220.53s17.09-8.33,16.86-19-22.78-17-23-25.37,9.48-13.45,9.48-13.45-15.31,5.61-15.08,16.15,15.15,17.36,16.71,24C265.31,212.17,258.14,220.53,258.14,220.53Z",
    style: {
      fill: "#ebebeb",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259,220.51s-17.4-5.87-17.59-14.26,22.09-14.27,22-20.82-10-10.2-10-10.2,15.52,3.81,15.7,12.1-16.64,14.35-17.7,21.12S259,220.51,259,220.51Z",
    style: {
      fill: "#ebebeb",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.73,
    y: 247.34,
    width: 16.43,
    height: 2.56,
    transform: "translate(-5.41 5.76) rotate(-1.26)",
    style: {
      fill: "#3175DB"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.72,
    y: 247.34,
    width: 16.43,
    height: 1.69,
    transform: "translate(-5.4 5.75) rotate(-1.26)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.05,241.06a9.3,9.3,0,0,0,9.34,3.75,9.16,9.16,0,0,0,1.65-.51,12.1,12.1,0,0,0,2.3-1.28l-2.16-3a7.53,7.53,0,0,1-1.21.72,5.46,5.46,0,0,1-6.92-1.86c-2.32-3.12-3.29-10.33-1.07-13.16.15-.2.8-.55,3.46,0,.49.1,1,.21,1.67.37a7.09,7.09,0,0,0,1.51.29l0-1.86.14-1.86c-.17,0-.44-.1-.79-.19a24.34,24.34,0,0,0-3.75-.69c-1.95-.16-4,.12-5.21,1.69C226.44,228,228.14,237.15,231.05,241.06Z",
    style: {
      fill: "#3175DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.18,240a7.53,7.53,0,0,1-1.21.72l1.07,3.6a12.1,12.1,0,0,0,2.3-1.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.25,221.7l1.19,3.94c.49.1,1,.21,1.67.37a7.09,7.09,0,0,0,1.51.29l0-1.86.14-1.86c-.17,0-.44-.1-.79-.19A24.34,24.34,0,0,0,235.25,221.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.08,215.87s-1.6,16.78-4.85,23.91-8,8-10.93,8.07l-5.37.12-5.37.12c-2.95.06-7.72-.62-11.28-7.59s-5.9-23.67-5.9-23.67Z",
    style: {
      fill: "#3175DB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M278.05,229.82c-.3,1.55-.64,3.08-1,4.53l-36.79.81c-.44-1.43-.84-2.94-1.22-4.48Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M276.56,236.07c-.23.8-.48,1.56-.74,2.27l-34.19.75c-.3-.69-.57-1.44-.84-2.24Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M278.8,225.57c-.12.74-.24,1.49-.38,2.26l-39.85.88c-.18-.76-.33-1.51-.48-2.24Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M155.51,205.82c-9.68,28.72-8.62,53.58-4.46,57.57,9.09,8.71,47.33-2.19,56.92-3.78,3.88-.64-8.68-31.44-12.71-30.27-9.51,2.76-23,7.84-23.5,7.71-1-.26-.26-8.88-2.09-31.61C168.2,187.05,159.46,194.08,155.51,205.82Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.75,222.39c.36,3.85-9.2,3.94-9.2,3.94a7.1,7.1,0,0,1,3.23,3.61c1,2.77-2.95,5.51-2.95,5.51a8.77,8.77,0,0,1,2.81,4.35c.66,2.75-2.91,6.07-2.91,6.07a8,8,0,0,1,.06,5.38c-2.95,7.68-24.2,9.66-30.37,8.94l-10.79-29.62s16.75-13.09,25.34-14.21C223.74,215.74,243.19,216.52,243.75,222.39Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.46,226.23c-5.16-1-10.55-.79-15.75-.52a.09.09,0,0,0,0,.18c5.18,0,10.55.71,15.72.59A.13.13,0,0,0,234.46,226.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.74,235.29a13.86,13.86,0,0,0-3.58.12c-1.27.13-2.53.28-3.79.45-2.52.35-5,.74-7.53,1.22-.11,0-.1.19,0,.18,2.52-.34,5-.64,7.56-.87l3.79-.32a16.35,16.35,0,0,0,3.56-.43A.18.18,0,0,0,234.74,235.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.63,245.88a9.47,9.47,0,0,0-3.22.28c-1.15.18-2.29.36-3.44.52-2.29.34-4.59.67-6.89.93a.09.09,0,1,0,0,.18c2.34-.25,4.69-.47,7-.73,1.15-.13,2.29-.27,3.44-.42a9,9,0,0,0,3.09-.64A.07.07,0,0,0,234.63,245.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.23,248.47a6.4,6.4,0,0,1-1,4.33,9,9,0,0,1-3.47,2.93,38.33,38.33,0,0,1-8.44,3.15,56.78,56.78,0,0,1-8.87,1.55,49.2,49.2,0,0,1-9,0h.08c-2.23.46-4.46.88-6.71,1.28q3.28-.94,6.59-1.82h.08a59.55,59.55,0,0,0,8.86-.39A70.14,70.14,0,0,0,222,258a47.94,47.94,0,0,0,8.37-2.83,9.11,9.11,0,0,0,3.44-2.59A6.48,6.48,0,0,0,235.23,248.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.93,228.79l7.33,34.81s-47.21,10.56-52.18-.56.17-47.21,7.58-61.57,12.29-6.84,13.42,3.34,2,30.69,2.27,30.68S193.93,228.79,193.93,228.79Z",
    style: {
      fill: "#3175DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.48,233.56c.7,5.18,3,19.18,5.77,28.07,0,.05.24,0,.23-.05-1.12-7.74-4.51-23-5.68-28.08C188.78,233.4,188.46,233.46,188.48,233.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.05,268a24.87,24.87,0,0,1-8.34-1.46,6.7,6.7,0,0,1-3.47-2.59,13.9,13.9,0,0,1-1.51-4.05,47.27,47.27,0,0,1-.84-8.45,59.43,59.43,0,0,1,.41-8.44c0,1.41,0,2.81,0,4.21s.07,2.81.15,4.21a53.58,53.58,0,0,0,1,8.31,13.08,13.08,0,0,0,1.35,3.84,6.45,6.45,0,0,0,3.12,2.43,21.58,21.58,0,0,0,4,1.26A38.3,38.3,0,0,0,161.05,268Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.12,229.68l-.22-.88,0,0c-3.55,1.25-7.13,2.43-10.71,3.6-1.79.6-3.59,1.14-5.38,1.72l-5.39,1.7L172,236l0-.48-.38-6c-.12-2-.27-4-.36-6-.22-4-.42-8-.54-12,.43,4,.78,8,1.12,11.95.18,2,.3,4,.46,6l.44,6-.48-.33,5.4-1.64c1.81-.54,3.6-1.11,5.41-1.63,3.62-1.06,7.24-2.11,10.87-3.1h0v0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.76,212.65a16.59,16.59,0,0,1-.16,2.54,13.24,13.24,0,0,1-.58,2.49C171.24,216,171.43,214.32,171.76,212.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.5,211c2,4.33,7.1,9.72,7.5,13.24a4.08,4.08,0,0,1-2.3,4.28s3.49,1.78,3.32,5c-.09,1.68-2.84,3-2.84,3s2.74,1.55,2.41,4.43c-.27,2.3-3,3.29-3,3.29s1.93,2.71.91,5c-2.07,4.57-21.92,4.4-24.93-2.94-1.4-3.42,3.45-3.12,3.45-3.12s-6.86-2.12-6.93-6.21,6.2-3.32,6.2-3.32-6.63-2.12-6.27-6.37c.37-4.43,6.51-2.57,6.51-2.57s-4.39-3-3.37-6.23c1.68-5.27,10,1.45,14.36.45L282,211.8Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.42,217.33c-1.54-4.26,3.77-9.45,2.88-13.74-1.21-5.79-7.77-.18-9.29,8.21l0,6.72Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.2,244.54a.05.05,0,0,1,0,.1,34.51,34.51,0,0,1-20.45-1.4c-.2-.09-.15-.46.09-.41A70.64,70.64,0,0,0,289.2,244.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.28,236.64c.08,0,.09.12,0,.14-6.75,1.54-15.37.94-22.2-2.91-.24-.14-.31-.49,0-.36C272.79,235.73,283.88,237.13,290.28,236.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.14,224.31c6.7,3.45,13.83,4.4,21.29,4.32.09,0,.09.14,0,.16-3.64,1-8.4.59-12.07-.08a19.77,19.77,0,0,1-9.34-4.17C267.91,224.46,268,224.24,268.14,224.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.94,188.39s2.33,3.35,2.45,6.51,2,35.72,1.88,37.42a3.66,3.66,0,0,1,1.48,1s14.47-5.2,16.83-4.87l1.23.68a108.5,108.5,0,0,0-3.74,16.68c-.86,7.49.88,22,.63,28.94s-11,33.29-12.38,40.15c-2.16,10.81,3.69,17.65,5.09,20.55,0,0-22.64-4.24-28.29-13.14S144.56,285,144.56,283s-4.49-4.9-5.24-12.22,11.89-60.6,14.39-68.83S164,190.05,164,190.05s1.55-5.1,5.56-5.17Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.75,233.33a40.49,40.49,0,0,0-4.34,3.93c-1.16,1.42-2.18,5.9-2.18,5.9",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.27,232.32a17.5,17.5,0,0,0-2.57,1.54,6.22,6.22,0,0,0-1.14,1.63",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,298.75c-1.52-7.93-2.4-14.82-2.4-15.76a2.65,2.65,0,0,0-.42-1.24c1.22-2.77,3.6-8.08,3.79-9.66.25-2,1.06-7.25,2.26-7.14s.3,11.16,1,13.29C151.77,279.85,148.55,292.64,147,298.75Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,190.05s.17,2.6.72,3.13,2.82,2.26,2.82,2.26",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.39,195.44a5.36,5.36,0,0,0,2.65,1.91",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.37,283.9c-1.28,2.46-4.22,16.31-3,17.65s6.08.42,6.08-3S156.76,281.23,155.37,283.9Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.7,274.76a41.79,41.79,0,0,1-2,8.78c.31-1.25-5-7.39-5.59-10s-6.17-7.09-5.06-10.48c.91-2.75,8.55-.31,12.51,4.42C189.68,270.32,189.77,272.84,189.7,274.76Z",
    style: {
      fill: "#c7c7c7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lines--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.06,205c0-1.59.09-3.17.18-4.76v-.1l.1-.06,1.63-1-.09.09c.39-.78.78-1.56,1.19-2.32l0-.06,0,0,2.12-1.49-.07.1c.33-.93.64-1.86,1-2.78l0,0h0c.41-.17.83-.35,1.25-.51-.39.23-.78.45-1.18.66l0,0c-.23,1-.51,1.9-.77,2.85l0,.06-.06,0c-.68.53-1.38,1-2.07,1.55l.07-.08c-.38.78-.78,1.56-1.19,2.33l0,.06-.05,0-1.66,1,.1-.16C150.48,201.86,150.31,203.44,150.06,205Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.8,196.36c1.33.49,2.64,1,3.95,1.61l.1,0v.13l.26,2.68-.13-.2c1,.49,2,1,3,1.55s2,1.07,2.95,1.61l.07,0v.07c0,.61-.07,1.22-.12,1.82,0-.6-.08-1.21-.11-1.82l.06.1c-1-.47-2.05-.93-3.05-1.43s-2-1-3-1.51l-.12-.06v-.13l-.18-2.69.11.17C198.31,197.7,197,197.06,195.8,196.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.86,268.43c1.7-.05,3.4-.13,5.09-.15s3.39-.07,5.09-.07l-.2.11,1.84-3.24.07-.13h.14l6.57,0-.09,0,4.1-2h0l3.27-1-3.19,1.26h0l-4,2.2,0,0h-.06l-6.57,0,.22-.13-1.88,3.22-.06.11H204c-1.7,0-3.39,0-5.09-.07S195.56,268.48,193.86,268.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,216.14c.56.69,1.11,1.38,1.63,2.08s1.06,1.4,1.56,2.12l.07.1,0,.11c-.48,1.27-1,2.53-1.5,3.78v-.16c.32,1,.61,1.92.88,2.88l0,.06,0,0c-.34.82-.71,1.63-1.09,2.43.25-.85.51-1.7.8-2.54v.1c-.36-.94-.7-1.88-1-2.83l0-.08,0-.08c.48-1.27,1-2.52,1.51-3.77l0,.21c-.5-.72-1-1.47-1.45-2.21S293.48,216.9,293,216.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.52,212.61q-1-3.62-1.88-7.26v-.07l0-.07c.38-1,.74-1.94,1.14-2.9l0,.06c.19-1.51.36-3,.58-4.53l0-.09.07,0L150,197l0,0c.49-.54,1-1.08,1.46-1.6-.42.59-.86,1.16-1.29,1.74v0h0l-1.52.84.09-.13c-.11,1.52-.28,3-.43,4.54v.06c-.36,1-.76,1.94-1.15,2.9v-.13Q147.9,208.91,148.52,212.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.34,152.84c1.3.82,2.57,1.69,3.83,2.57l0,0,0,0,1.42,2.61-.06-.07,2,1.72.08.07v.1c0,1.74-.09,3.49-.22,5.24-.13-1.75-.2-3.5-.22-5.24l.07.17-2-1.68,0,0,0,0-1.36-2.64.07.08C199.71,154.81,198.5,153.85,197.34,152.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.32,224.61c.58,1.33,1.13,2.66,1.66,4l0,.06,0,.07c-.43,1.15-.88,2.28-1.34,3.42s-.9,2.28-1.38,3.41l0-.1c.07,1.19.18,2.37.23,3.56v.05l0,0c-.64,1.44-1.3,2.87-2,4.28.52-1.49,1.09-3,1.66-4.42v.08c-.14-1.18-.22-2.37-.33-3.56v-.05l0,0c.44-1.15.91-2.28,1.38-3.41s.94-2.27,1.44-3.39v.13C297.19,227.37,296.74,226,296.32,224.61Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--trash-bin--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,424c1.55.5,2.93,1.63,3.81.12s3.25-1.06,4.13-1.38,2.11-2.87,2-3.67-.72-1.61-.72-2.36,0-1.87-.14-2.91-.19-2.52-1.8-3.27a7.86,7.86,0,0,0-3.56-.57c-1-.1-1.76-1.73-3.78-2.35s-4.66,1.64-4.9,2.54-.42,3.65-1.17,4.68-1.8.68-2,1.95-.11,3.37.26,3.75,1.35-.19,1.8.58.85,2.78,1.78,3.25S111.32,423.65,112.5,424Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.74 362.26 93.77 364.24 93.7 363.52 93.7 363.5 94.96 362.26 95.74 362.26",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.2 362.26 96.5 369 94.34 371.14 94.31 370.69 94.31 370.68 94.28 370.43 96.1 368.6 102.48 362.26 103.2 362.26",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.67 362.26 100.25 372.75 94.94 378.03 94.92 377.93 94.88 377.34 99.85 372.34 110 362.26 110.67 362.26",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.15 362.26 104 376.5 95.52 384.92 95.46 384.26 103.59 376.09 117.5 362.26 118.15 362.26",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.59,362.26q-1.52,1.56-3,3.1l-14.8,14.89L96.1,391.82l0-.62,11.28-11.36,14.88-14.79c.94-.94,1.89-1.87,2.84-2.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,362.26c-2.24,2.29-4.48,4.56-6.74,6.84L111.5,384,96.69,398.7l0-.58,14.44-14.53L126,368.79q3.32-3.27,6.64-6.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.42,362.26c-3.45,3.55-6.91,7.07-10.39,10.6l-14.79,14.87-14.89,14.8q-1.53,1.53-3.08,3l0-.48c.92-1,1.87-1.91,2.81-2.86l14.8-14.89,14.88-14.78q5.22-5.18,10.48-10.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.71,362.34v0q-6.94,7.14-13.93,14.22L119,391.49,104.1,406.27l-6.25,6.15,0-.38,6-6.08,14.79-14.88,14.89-14.79Q140.55,369.29,147.71,362.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,370.41v0l0,.25h0q-4.74,4.85-9.49,9.66l-14.78,14.88L107.85,410q-4.69,4.64-9.42,9.24v0l0-.23q4.56-4.67,9.14-9.3l14.78-14.88L137.21,380C140.47,376.82,143.75,373.6,147,370.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.35,378.49l0,.5-5,5.1L126.48,399,111.6,413.77q-6.07,6-12.21,12h-.14q6-6.18,12-12.28l14.8-14.89L141,383.78Q143.64,381.13,146.35,378.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.66,386.59l-.06.65-.58.6-14.79,14.89-14.89,14.78q-4.17,4.14-8.36,8.23h-.34q4.2-4.28,8.39-8.54l14.79-14.87,14.89-14.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,394.75l-.06.72-10.93,11-14.89,14.8c-1.51,1.5-3,3-4.54,4.47h-.48q2.35-2.4,4.72-4.78l14.79-14.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.27,402.9l-.06.79-6.49,6.53L122.84,425c-.25.24-.49.49-.75.73h-.59l1-1,14.79-14.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.58 411.06 143.51 411.92 141.47 413.96 129.61 425.74 128.96 425.74 141.06 413.56 143.58 411.06",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.89 419.24 142.89 419.27 142.82 420.1 137.14 425.74 136.44 425.74 142.89 419.24",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.62 363.5 147.55 364.25 145.58 362.26 146.36 362.26 147.62 363.5",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.03 370.43 146.96 371.14 144.81 369 138.11 362.26 138.84 362.26 145.21 368.6 147.03 370.43",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.44 377.34 146.39 377.93 146.38 378.04 141.06 372.75 130.63 362.26 131.32 362.26 141.47 372.34 146.44 377.34",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.85 384.28 145.8 384.93 137.32 376.5 123.17 362.26 123.8 362.26 137.72 376.09 145.85 384.28",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.27,391.21l-.06.61-11.64-11.57-14.79-14.89q-1.53-1.55-3-3.1h.52c1,.92,1.9,1.85,2.83,2.79L134,379.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.68,398.12l-.05.58L129.82,384,115,369.1l-6.74-6.84h.41l6.64,6.53,14.89,14.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.09,405.08l0,.5L141,402.53l-14.88-14.8-14.8-14.87c-3.47-3.53-6.94-7.05-10.38-10.6h.22q5.25,5.12,10.48,10.29l14.88,14.78,14.8,14.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.5,412l0,.38c-2.09-2-4.17-4.09-6.26-6.15l-14.89-14.78L107.54,376.6q-7-7.08-13.93-14.22v0q7.15,6.95,14.24,14l14.89,14.79L137.52,406Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.91,419l0,.26q-4.74-4.59-9.42-9.24l-14.89-14.8-14.79-14.88q-4.76-4.8-9.48-9.66h0l0-.27c3.29,3.19,6.56,6.41,9.82,9.62L119,394.83l14.8,14.88Q138.37,414.35,142.91,419Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.07,425.74h-.14q-6.13-6-12.21-12L114.84,399,100,384.09,95,379l0-.5,5.38,5.29,14.89,14.79L130,413.46C134.05,417.54,138.08,421.62,142.07,425.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.67,425.74h-.33c-2.8-2.73-5.58-5.47-8.37-8.23l-14.89-14.78L96.3,387.84l-.59-.6,0-.64c.32.3.63.62,1,.93l14.89,14.8,14.78,14.87Q130.5,421.46,134.67,425.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.24,425.74h-.46c-1.53-1.49-3-3-4.56-4.47l-14.88-14.8-10.93-11,0-.73,11.38,11.32L122.54,421C124.11,422.55,125.69,424.14,127.24,425.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.82,425.74h-.6l-.74-.73-14.89-14.79-6.48-6.52-.07-.8,7,6.91,14.79,14.89C119.13,425,119.47,425.4,119.82,425.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.36 425.74 111.7 425.74 99.85 413.96 97.81 411.92 97.81 411.9 97.73 411.07 100.25 413.56 112.36 425.74",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.88 425.74 104.17 425.74 98.5 420.1 98.43 419.24 104.88 425.74",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.93,
    y: 362.25,
    width: 1.14,
    height: 63.62,
    transform: "translate(-35.4 10.4) rotate(-5.21)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.15,
    y: 393.49,
    width: 63.62,
    height: 1.14,
    transform: "translate(-260.74 502.27) rotate(-84.74)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.26,
    y: 355.33,
    width: 60.7,
    height: 10.28,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.52,
    y: 420.24,
    width: 48.19,
    height: 10.28,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.47,416.38c1.82-.27,4.17-.27,4.3.78s-.7,1.6-.44,2.13a23.29,23.29,0,0,0,2.44,2.17,5.07,5.07,0,0,1,1.21,2.17c0,.26.44.69,0,1.22s-.68,1.3-1,1.69-.51.82,0,1.52.08,2.69-.7,3.39-3-1-3.74-.78-.78.51-1.39.95a6.75,6.75,0,0,1-3.65,1.48c-1.56,0-2.34-1.39-3.3-2a13.21,13.21,0,0,0-2.69-1,4.9,4.9,0,0,1-2-1.48c-.17-.35-.78-.43-.52-1.39s.69-1.22.69-2,0-.92,0-1.8-.7-2.45-.09-3.15,1-1.74,2-1.74,4,.52,4,.52a7.49,7.49,0,0,0,.87-1.12,2.49,2.49,0,0,1,2.1-1.22A6.28,6.28,0,0,0,140.47,416.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.65,425.19c1.24.58,2.51,1.09,3.78,1.59s2.52,1,3.8,1.5a33.28,33.28,0,0,0,3.82,1.24,2.52,2.52,0,0,0,.79.09l.77-.38a12.15,12.15,0,0,0,1.66-1,4.57,4.57,0,0,0,1.27-1.29,3.14,3.14,0,0,0,.18-.37l.06-.19,0-.09h0a1.48,1.48,0,0,0-.33-.58,18.9,18.9,0,0,0-3-2.6c-1.08-.81-2.21-1.56-3.37-2.28-.57-.37-1.14-.73-1.74-1.07-.29-.16-.59-.32-.9-.47a3.82,3.82,0,0,0-.46-.21c-.14,0-.34-.17-.46,0,.1-.16.33-.06.49,0l.5.14c.33.1.65.23,1,.36.63.26,1.26.55,1.88.85,1.22.63,2.42,1.31,3.59,2.05A16,16,0,0,1,146.3,425a2.15,2.15,0,0,1,.6,1.2,1.15,1.15,0,0,1,0,.26l0,.16-.09.3a3.1,3.1,0,0,1-.26.55,5.58,5.58,0,0,1-1.55,1.65,13.25,13.25,0,0,1-1.83,1.1l-.47.23-.23.12-.13.05a1.29,1.29,0,0,1-.26.08,3.25,3.25,0,0,1-1.23-.13,25,25,0,0,1-3.91-1.48A52.58,52.58,0,0,1,129.65,425.19Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.84,427.55a22.79,22.79,0,0,1,2.25-3c.41-.48.85-.93,1.3-1.38.23-.22.47-.43.72-.64a4.09,4.09,0,0,1,.91-.6l.18-.07a1.43,1.43,0,0,1,.36,0,1,1,0,0,1,.48.26,3.33,3.33,0,0,1,.36.44,7.55,7.55,0,0,1,.52.83c.3.56.6,1.11.84,1.69a15.29,15.29,0,0,1,1.19,3.57l-2-3.15c-.34-.52-.65-1.05-1-1.55-.17-.25-.33-.51-.5-.73s-.17-.2-.24-.28,0,0,.09,0a.15.15,0,0,0,.13,0l0,0a3.1,3.1,0,0,0-.63.42l-.7.57-1.39,1.19C136.79,426,135.85,426.8,134.84,427.55Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.74,435.08c-1,.24-2.28.36-2.4-.21s.3-.91.13-1.19a11.71,11.71,0,0,0-1.45-1.06,2.84,2.84,0,0,1-.77-1.13c0-.14-.28-.36-.07-.67s.31-.75.48-1,.24-.48-.08-.83a1.86,1.86,0,0,1,.22-1.89c.39-.42,1.71.37,2.08.23s.4-.32.72-.59a3.71,3.71,0,0,1,1.92-1c.86-.08,1.36.64,1.91.93a7.11,7.11,0,0,0,1.53.43,2.77,2.77,0,0,1,1.17.71c.11.18.45.2.36.73s-.32.7-.28,1.13,0,.51.09,1,.51,1.31.21,1.72-.48,1-1,1.06-2.21-.08-2.21-.08a4.25,4.25,0,0,0-.42.66,1.38,1.38,0,0,1-1.09.77A3.54,3.54,0,0,0,111.74,435.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,429.5c.52-.57,1.09-1.07,1.63-1.6l.42-.38.21-.19a1.1,1.1,0,0,1,.42-.2,6.7,6.7,0,0,1,1.22-.16,11.69,11.69,0,0,1,2.36.14,3.73,3.73,0,0,1,1.27.39,1.29,1.29,0,0,1,.57.78,2.73,2.73,0,0,1,.09.72,7.39,7.39,0,0,1-.54,2.4,7.81,7.81,0,0,1-.51,1.1,3.92,3.92,0,0,1-.33.54,1.45,1.45,0,0,1-.64.49,5.88,5.88,0,0,1-2.44.16,17.1,17.1,0,0,1-2.27-.4c.76-.06,1.52-.07,2.27-.16a6.91,6.91,0,0,0,2.07-.41c.15-.08.11-.07.22-.23a3.77,3.77,0,0,0,.23-.45,8.58,8.58,0,0,0,.38-1,7.07,7.07,0,0,0,.42-2,.84.84,0,0,1,.25-.55,7.21,7.21,0,0,0-1.24-.28,15.53,15.53,0,0,0-2.17-.31,7.49,7.49,0,0,0-1.06,0c-.07,0-.13,0-.11,0l-.24.15-.49.31C109.28,428.72,108.64,429.14,108,429.5Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.32,428c0,.73,0,1.43.07,2.08,0,.29.09.66.17.68s0,0,0,0,0,0,.07,0a3.22,3.22,0,0,0,.39,0c.62-.1,1.29-.29,2-.43a13.74,13.74,0,0,1,2.1-.34,7.76,7.76,0,0,1-1.8,1.18,8,8,0,0,1-2.07.72,4.37,4.37,0,0,1-.65,0,1.61,1.61,0,0,1-.44-.1,1,1,0,0,1-.41-.37,2,2,0,0,1-.18-1.35A5.18,5.18,0,0,1,110.32,428Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.45,420.18c-.51-1.54-.42-3.33-2.16-3.14s-2.78-2-3.56-2.5-3.56,0-4.17.52-.87,1.53-1.48,2-1.48,1.14-2.26,1.84-1.91,1.65-1.56,3.39a7.87,7.87,0,0,0,1.65,3.2c.52.88-.35,2.44.35,4.44s4.08,2.78,4.95,2.43,3.19-1.82,4.46-1.82,1.62,1,2.75.43,2.78-1.91,2.87-2.43-1-1-.61-1.79,1.74-2.34,1.56-3.36S103.84,421.36,103.45,420.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.23,416.86A49,49,0,0,0,94,419.35a4.3,4.3,0,0,0-.63.42c-.08,0-.13.39-.18.63-.09.55-.16,1.11-.22,1.66-.11,1.12-.2,2.24-.2,3.35a9.37,9.37,0,0,0,.09,1.61,1.1,1.1,0,0,0,.11.43,1.83,1.83,0,0,0,.61.19,16.84,16.84,0,0,0,3.27.16,14.34,14.34,0,0,0,1.63-.13c.47-.07,1.11-.23,1.64-.33,1.11-.22,2.22-.43,3.28-.71a6.69,6.69,0,0,0,.75-.22l.13-.05h0a.18.18,0,0,0-.08.11.59.59,0,0,0,0,.41.63.63,0,0,0,.11.19.22.22,0,0,0,.07.06h0l-.15-.06c-.48-.16-1-.29-1.58-.42l-3.31-.74c-1.1-.24-2.21-.49-3.32-.77-.55-.14-1.11-.28-1.67-.48a2.94,2.94,0,0,1-.93-.48l-.1-.12a.69.69,0,0,1-.08-.21.74.74,0,0,1,0-.21.85.85,0,0,1,.06-.31,2.55,2.55,0,0,1,.2-.47,14,14,0,0,1,2.15-2.76c.2-.21.41-.41.63-.61l.34-.28a1.33,1.33,0,0,1,.19-.14.73.73,0,0,1,.29-.15.82.82,0,0,1,.64.16,2.2,2.2,0,0,1,.37.3,6,6,0,0,1,.6.64,43.67,43.67,0,0,1,3.7,5.73,55.58,55.58,0,0,0-4.12-5.36,7.6,7.6,0,0,0-.58-.56,1.49,1.49,0,0,0-.45-.29c.07,0-.05,0-.08.06l-.14.12-.3.27c-.19.19-.38.4-.56.6a13.73,13.73,0,0,0-1.9,2.67,3.21,3.21,0,0,0-.12.31s0,.11,0,.1h0a.38.38,0,0,0,0-.12l0,0a2.84,2.84,0,0,0,.59.23c.51.17,1,.3,1.6.43,1.09.26,2.19.49,3.3.72l4.24.81c.56.12.19.11.79.3l.24.09.18.09.15.12a.76.76,0,0,1,.14.24.68.68,0,0,1,0,.46,1.09,1.09,0,0,1-.23.25.89.89,0,0,1-.16.1,1.85,1.85,0,0,1-.26.12c-.31.12-.59.19-.87.27-1.14.27-2.25.47-3.36.68-.59.09-1.05.21-1.7.31a17.49,17.49,0,0,1-1.75.11,18,18,0,0,1-3.49-.23,2.57,2.57,0,0,1-1-.36,1.08,1.08,0,0,1-.4-.59,2.75,2.75,0,0,1-.1-.5,11.81,11.81,0,0,1,0-1.78c.06-1.15.2-2.28.37-3.41.09-.56.18-1.13.3-1.69.11-.29,0-.55.39-.94a3.09,3.09,0,0,1,.8-.48,27.57,27.57,0,0,1,3.23-1.14C98,417.39,99.12,417.09,100.23,416.86Z",
    style: {
      fill: "#c7c7c7"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatient);
export default __webpack_public_path__ + "static/media/patient.f8eedc47f6b281761c6475aa3a205117.svg";
export { ForwardRef as ReactComponent };